import { Camera, ChevronRight, HardDrive, Monitor, Server } from 'lucide-react';
import { memo } from 'react';
import { Link } from 'react-router-dom';
import type { Device } from '../types';
import { deviceTypeLabels, statusLabels } from '../utils/format';

const typeIcons = {
  camera: Camera,
  recorder: HardDrive,
  computer: Monitor,
  server: Server,
};

export const DeviceListItem = memo(function DeviceListItem({ device }: { device: Device }) {
  const Icon = typeIcons[device.type];
  const isReserved = device.camera?.isReservedChannel ?? false;
  const isWarning = !isReserved && (device.status === 'warning' || device.status === 'critical');
  const statusTone = isReserved ? 'offline' : isWarning ? 'warning' : device.isOnline ? 'online' : 'offline';
  const statusLabel = isReserved ? 'Резервный канал' : isWarning ? 'Предупреждение' : device.isOnline ? 'Онлайн' : statusLabels[device.status];

  return (
    <Link
      className="device-list-item"
      to={device.type === 'camera' ? `/devices/cameras/${device.id}` : `/devices/${device.id}`}
      aria-label={`${device.name}, ${deviceTypeLabels[device.type]}, ${statusLabel}`}
    >
      <span className={`device-list-item__icon device-list-item__icon--${device.type}`} aria-hidden="true">
        <Icon size={21} strokeWidth={2} />
      </span>
      <span className="device-list-item__identity">
        <strong>{device.name}</strong>
        <span>{device.location}</span>
        <span className={`device-list-item__status device-list-item__status--${statusTone}`}>
          <i aria-hidden="true" />
          {statusLabel}
        </span>
      </span>
      <ChevronRight className="device-list-item__chevron" size={21} strokeWidth={1.8} aria-hidden="true" />
    </Link>
  );
});
